import React, { useState } from 'react';
import { Table, Pagination } from 'antd';
import { TableItem } from '../../../StyledComponents/Common';
import styled from 'styled-components';



const SimpleTableScroll = (props) => {

  const startIndex = (props.currentPage - 1) * props.pageSize;
  const endIndex = startIndex + props.pageSize;
  const currentData = props?.data?.slice(startIndex, endIndex);

  return (
    <div className="tableResponsiveASAP">
    <TableContainer className="tableUserManagement">
      <TableItem width="1000px" rowKey={props.rowKey ? props.rowKey : "id"} columns={props.columns} dataSource={currentData} 
      scroll={props.scroll ?{ x: 800, y: 400 } : null} pagination={false} fpadding={props.fpadding} showScroll={props.showScroll} className={props.className} />
    </TableContainer>
    </div>
  );
};

export default SimpleTableScroll;

const TableContainer = styled.div`
  
  width: 100%; 
  
`